import React, { useState } from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import PurchaseStyles from '../PurchaseStyles'
import { Backdrop, Button, ButtonGroup, CircularProgress, FormControl, Container, FormHelperText, Grid, Input, TextField, InputAdornment } from '@material-ui/core'
import UseForm from '../../common/UseForm'
import * as purchaseActions from '../../../actions/purchase/PurchaseActions'
import Typography from '@material-ui/core/Typography'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import CardContent from '@material-ui/core/CardContent'
import PdfIcon from '@material-ui/icons/PictureAsPdfOutlined'
import XmlIcon from '@material-ui/icons/DescriptionOutlined'

const PurchaseUploadAccesoryInvoice = ({ classes, ...props }) => {
    const history = useHistory()
    const [loading, setLoading] = useState(false)

    const [amountProcedure, setAmountProcedure] = useState({
        amount: "",
    });

    const handleChangeAmount = (e) => {
        const { name, value } = e.target;
        setAmountProcedure((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const initialFieldValues = {
        orderId: parseInt(props.orderId),
        accesoryId: props.accessory.id,
        isAccessory: true,
        affect: props.accessory.affect,
        description: props.accessory.description,
        pdf: {},
        xml: {},
        invoiceType: "",
        documentType: "",
        chargeCode: "",
        paymentType: "",
        feature_typ_cd: props.accessory.feature_typ_cd,
    }

    const {
        values,
        handleInpuFileChange,
        errors,
        setErrors,
        resetForm
    } = UseForm(initialFieldValues)

    const handleCloseBackdrop = () => {
        setLoading(false);
    }

    const handleOpenBackdrop = () => {
        setLoading(true);
    }

    const InvoiceFilesCombination = (values) => {
        switch (values.affect) {
            case false:
                values.documentType = "CARGO"
                values.chargeCode = "MISE"
                values.paymentType = "REGULAR"
                values.invoiceType = "ACNOT"
                break;
            case true:
                values.documentType = "CARGO"
                values.chargeCode = "UACL"
                values.paymentType = "REGULAR"
                values.invoiceType = "AC"
                break;
            default:
                break;
        }
    }

    const handleSubmit = () => {
        const formData = new FormData()
        if (Object.keys(values.pdf).length !== 0 && Object.keys(values.xml).length !== 0) {
            handleOpenBackdrop()
            InvoiceFilesCombination(values)

            formData.append('OrderId', values.orderId)
            formData.append('IsAccessory', values.isAccessory)
            formData.append('Affect', values.affect)
            if (values.feature_typ_cd === 2){
                formData.append('InvoiceType', "ACNOTGES")
            }
            else{
            formData.append('InvoiceType', values.invoiceType)
            }
            formData.append('DocumentType', values.documentType)
            formData.append('ChargeCode', values.chargeCode)
            formData.append('PaymentType', values.paymentType)
            formData.append('AccessoryId', values.accesoryId)

            for (let file of values.pdf) {
                formData.append("Pdf", file);
            }
            for (let file of values.xml) {
                formData.append("Xml", file);
            }

            props.purchaseActions.upload_invoice(props.userLanguage, props.userToken, values.orderId, formData, onError, onSuccess)
        } else {
            if (Object.keys(values.pdf).length !== 0 && amountProcedure !== "" && amountProcedure != null) {
                if (values.feature_typ_cd === 3) {
                    handleOpenBackdrop()
                    InvoiceFilesCombination(values)
                    console.log(values)
                    formData.append("OrderId", values.orderId);
                    formData.append('AccessoryId', values.accesoryId)
                    formData.append("InvoiceType", 'RIG');
                    formData.append("DocumentType", values.documentType);
                    formData.append("ChargeCode", values.chargeCode);
                    formData.append("PaymentType", values.paymentType);
                    formData.append("IsAccessory", false);
                    formData.append("IsRight", true);
                    formData.append("RightAmount", parseFloat(amountProcedure.amount).toFixed(2));

                    for (let file of values.pdf) {
                        formData.append("Right", file);
                    }

                    props.purchaseActions.upload_invoice(props.userLanguage, props.userToken, values.orderId, formData, onError, onSuccess)

                }
            } else {
                toast.error('Debe seleccionar el archivo y proporcionar un monto', { className: classes.toastError })
            }
        }
    }

    const handleDownload = (documentId, documentType) => {
        handleOpenBackdrop()
        props.purchaseActions.download_document('es-MX', props.userToken, onError, documentId, values.orderId, documentType, onSuccessHistory)
    }

    const handleDelete = (invoiceId, type) => {
        handleOpenBackdrop()
        if (type === 3) {
            props.purchaseActions.delete_right(
                            "es-MX",
                            props.userToken,
                            onError,
                            invoiceId,
                            values.orderId,
                            onSuccessDeleteInvoice
                        );
        }
        else {
            props.purchaseActions.delete_invoice('es-MX', props.userToken, onError, invoiceId, values.orderId, onSuccessDeleteInvoice)

        }
    }

    const onSuccessHistory = () => {
        handleCloseBackdrop()
    }

    const onSuccessDeleteInvoice = () => {
        props.purchaseActions.fetch_order_detail(props.userLanguage, props.userToken, props.orderId, onError)
        props.purchaseActions.fetch_documents(props.userLanguage, props.userToken, values.orderId, onError, onSuccessHistory)
        setAmountProcedure(0)
    }

    const onSuccess = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            toast.success('Se agregó correctamente la factura', { className: classes.toastSuccess })
            resetForm()
            ClearXML()
            ClearPDF()
            setAmountProcedure(0)
        } else {
            toast.error('Ocurrió un error al validar la factura', { className: classes.toastError })
        }
        props.purchaseActions.fetch_invoice_errors(props.userLanguage, props.userToken, props.orderId, onError, onSuccessHistory)
        props.purchaseActions.fetch_documents(props.userLanguage, props.userToken, props.orderId, onError, onSuccessHistory)
        props.purchaseActions.fetch_order_detail(props.userLanguage, props.userToken, props.orderId, onError)
    }

    const ClearXML = () => {
        Array.from(document.querySelectorAll('div.fileXML > input')).forEach(
            input => (input.value = "")
        )
    }

    const ClearPDF = () => {
        Array.from(document.querySelectorAll('div.filePDF > input')).forEach(
            input => (input.value = "")
        )
    }

    const formatCurrency = (value) => {
  if (value == null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    let temp = { ...errors }
                    var pdf = err.response.data.errors.Pdf && err.response.data.errors.Pdf[0]
                    var xml = err.response.data.errors.Xml && err.response.data.errors.Xml[0]
                    var invoiceType = err.response.data.errors.InvoiceType && err.response.data.errors.InvoiceType[0]

                    if (pdf) {
                        temp.pdf = pdf
                    }
                    if (xml) {
                        temp.xml = xml
                    }
                    if (invoiceType) {
                        temp.invoiceType = invoiceType
                    }

                    setErrors({
                        ...temp
                    })
                    break;
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]

        if (file != null) {
            let types = ['text/xml']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        let types = []
        if (file != null) {
            if (values.feature_typ_cd === 3)
             types = ['application/pdf', 'image/png','image/jpeg']
        else
            types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    return (
        <div>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Container className={classes.generalBorder}>
                <CardContent>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={2}
                    >
                        <Grid item xs={4}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>Accesorio</Typography>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>{values.description}</Typography>
                        </Grid>
                        {props.accessory.feature_typ_cd === 1 &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>Tipo de factura</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>Accesorio</Typography>
                            </Grid>
                        }
                        {props.accessory.feature_typ_cd === 2 &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>Tipo de factura</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>Gestoria</Typography>
                            </Grid>
                        }
                        {props.accessory.feature_typ_cd === 3 &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>Tipo de Documento</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>Derecho</Typography>
                            </Grid>
                        }
                        {props.accessory.feature_typ_cd === 1 &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>UUID</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>{props.accessory.accesoryInvoice && props.accessory.accesoryInvoice.uuid}</Typography>
                            </Grid>
                        }
                        {props.accessory.feature_typ_cd === 2 &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>UUID</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>{props.accessory.accesoryInvoice && props.accessory.accesoryInvoice.uuid}</Typography>
                            </Grid>
                        }
                         { props.accessory.feature_typ_cd === 3 && props.accessory.accesoryInvoice &&  props.accessory.accesoryInvoice.custBilledAmt &&
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>Monto</Typography>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>{props.accessory.accesoryInvoice && formatCurrency
                                (props.accessory.accesoryInvoice.custBilledAmt)}</Typography>
                            </Grid>
                        }
                    </Grid>
                </CardContent>
                <CardContent>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        spacing={2}
                    >

                        <Grid item xs={4}>
                            {!props.accessory.accesoryInvoice && props.accessory.feature_typ_cd === 3 ? (

                                <TextField
                                    fullWidth
                                    type="number"
                                    name="amount"
                                    label="Monto"
                                    value={amountProcedure.amount}
                                    onChange={handleChangeAmount}
                                    onBlur={() => {
                                        const value = parseFloat(amountProcedure.amount);
                                        if (!isNaN(value)) {
                                            const formatted = value.toFixed(2);
                                            setAmountProcedure((prev) => ({
                                                ...prev,
                                                amount: formatted,
                                            }));
                                        }
                                    }}
                                    inputProps={{
                                        step: "0.01",
                                        min: 0,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        sx: {
                                            "& input[type=number]::-webkit-outer-spin-button": { display: "none" },
                                            "& input[type=number]::-webkit-inner-spin-button": { display: "none" },
                                            "& input[type=number]": { MozAppearance: "textfield" },
                                        }
                                    }}

                                />
                            ) : !props.accessory.accesoryInvoice ? (
                                <FormControl {...(errors.xml && { error: true })}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                                        Archivo Xml
                                    </Typography>
                                    <Input
                                        type="file"
                                        name="xml"
                                        id={"xml" + values.accesoryId}
                                        className="fileXML"
                                        onChange={checkFileTypeXML}
                                    />
                                    <FormHelperText>{errors.xml && errors.xml}</FormHelperText>
                                </FormControl>
                            ) : null}
                        </Grid>


                        {

                            !props.accessory.accesoryInvoice &&
                            <Grid item xs={4}>
                                <FormControl  {...(errors.pdf && { error: true })}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>Archivo Pdf</Typography>
                                    <Input
                                        type="file"
                                        name="pdf"
                                        id={"pdf" + values.accesoryId}
                                        className="filePDF"
                                        onChange={checkFileTypePDF}
                                    />
                                    <FormHelperText>{errors.pdf && (errors.pdf)}</FormHelperText>
                                </FormControl>
                            </Grid>
                        }

                        <Grid item xs={4} className={classes.alignCenter}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>Acciones</Typography>
                            <ButtonGroup size="small" aria-label="Small outlined button group">
                                {
                                    !props.accessory.accesoryInvoice &&
                                    <Button style={{ border: '0px' }} title="Cargar" onClick={handleSubmit}>
                                        <CloudUploadIcon />
                                    </Button>
                                }
                                {
                                    props.accessory.accesoryInvoice && (
                                        <div >
                                            {(props.accessory.feature_typ_cd === 1 || props.accessory.feature_typ_cd === 2) ?
                                                <Button style={{ color: '#EC4235', border: '0px' }} title="Descargar Pdf" onClick={() => handleDownload(props.accessory.accesoryInvoice.pdfBuketName, 'pdf')}>
                                                    <PdfIcon />
                                                </Button>

                                                :
                                                <Button style={{ color: '#EC4235', border: '0px' }} title="Descargar Pdf" onClick={() => handleDownload(props.accessory.accesoryInvoice.pdfBuketName, 'DERECHO')}>
                                                    <PdfIcon />
                                                </Button>
                                            }
                                            {(props.accessory.feature_typ_cd === 1 || props.accessory.feature_typ_cd === 2) &&
                                                <Button style={{ color: '#5F5F5F', border: '0px' }} title="Descargar Xml" onClick={() => handleDownload(props.accessory.accesoryInvoice.xmlBuketName, 'xml')}>
                                                    <XmlIcon />
                                                </Button>
                                            }

                                            {
                                                !props.accessory.accesoryInvoice.acceptanceByNvp && (
                                                    <Button style={{ color: '#BF2E2E', border: '0px' }} title="Eliminar" onClick={() => handleDelete(props.accessory.accesoryInvoice.invoiceId, props.accessory.feature_typ_cd)}>
                                                        <DeleteForeverIcon />
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </CardContent>
            </Container>
            <ToastContainer />
        </div >
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        purchaseActions: bindActionCreators(purchaseActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PurchaseStyles)(PurchaseUploadAccesoryInvoice))
